// Antworten im Wortlaut: die gewählte Zelle der Matrix markieren. Ein- und
// Ausblenden der Antworten übernimmt CSS (:target) - das funktioniert auch
// ohne dieses Skript.
export default function answerMatrix() {
  const cells = document.querySelectorAll('[data-answer-group]');
  if (!cells.length) return;

  function mark() {
    const target = decodeURIComponent(window.location.hash.slice(1));
    cells.forEach(function (cell) {
      const active = cell.dataset.answerGroup === target;
      cell.classList.toggle('is-active', active);
      if (active) cell.setAttribute('aria-current', 'true');
      else cell.removeAttribute('aria-current');
    });
  }

  window.addEventListener('hashchange', mark);
  mark();
}
